/* 
These functions make sure WordPress 
and Foundation play nice together.
*/

jQuery(document).ready(function() {
  	widgetSlider();
  	siteJsEssentials();
  	initParallax();
  	coolColorOverLay();
  	initHpVideo();
	checkVideo();
	initScroller();	
	//formLabel2Placeholder();
	cf7fix();
	//fmDebugr();
	eventsFixParallax();
	startSliders();
	expandContent();
	jQuery('.parallax-window').parallax({
	});
});

function expandContent() {
	jQuery('.expandMore').on('click', function(e){
		jQuery(this).parent().find('.mobileExpand').toggleClass('showAll');
		jQuery(this).toggleClass('showClicked');
		e.preventDefault();
	});
	
}

function startSliders(){
	jQuery('.sliderTime').flickity({
		// options
		autoPlay: 8000,
		cellAlign: 'left',
		contain: true,
		cellSelector: '.sliderBanner',
		wrapAround: true,
		pageDots: true,
		prevNextButtons: false,
		dragThreshold: 25,
	});
	// console.log('slider started');
	jQuery('.specialtiesSlider').flickity({
		// options
		watchCSS: true,
		autoPlay: 6000,
		cellAlign: 'left',
		contain: true,
		cellSelector: '.specialtiesSlide',
		wrapAround: true,
		pageDots: false,
		dragThreshold: 25,
		arrowShape: { 
		  x0: 10,
		  x1: 60, y1: 50,
		  x2: 70, y2: 40,
		  x3: 30
		}
	});

	jQuery('.reviewsSlider').flickity({
		// options
		autoPlay: false,
		cellAlign: 'left',
		contain: true,
		cellSelector: '.reviewSlide',
		wrapAround: true,
		pageDots: false,
		dragThreshold: 25,
		arrowShape: { 
		  x0: 10,
		  x1: 60, y1: 50,
		  x2: 70, y2: 40,
		  x3: 30
		}
	});
	jQuery(window).trigger('resize.px.parallax');
}

function eventsFixParallax(){
	jQuery(window).on(
		'postequalized.zf.equalizer', function(){
			jQuery(window).trigger('resize.px.parallax');
		}
	);
	jQuery(window).on(
		'change.zf.tabs', function(){
			jQuery(window).trigger('resize.px.parallax');
		}
	);
	jQuery(window).on(
		'down.zf.accordion', function(){
			jQuery(window).trigger('resize.px.parallax');
		}
	);
	jQuery(window).on(
		'up.zf.accordion', function(){
			jQuery(window).trigger('resize.px.parallax');
		}
	);	
}

function fmDebugr() {
	var currentBreakpoint = Foundation.MediaQuery.current;
	console.log('the current breakpoint is ' + currentBreakpoint);
	jQuery(window).resize(function() {
		//new Foundation.Equalizer(jQuery(".outerOdd, .outerEven")).applyHeight();
		var currentBreakpoint = Foundation.MediaQuery.current;
		console.log('the current breakpoint is ' + currentBreakpoint);
	});	
}

jQuery(window).resize(function() {	
	navCheck();
});

jQuery(window).scroll(function() { 
	navCheck();
});


// dont forget to put the CSS
// form.form label { display: none; }
//
function formLabel2Placeholder() {
    jQuery("form :input").each(function(index, elem) {
        var eId = jQuery(elem).attr("id");
        var label = null;
        if (eId && (label =  jQuery(elem).parents("form").find("label[for="+eId+"]")).length == 1) {
             jQuery(elem).attr("placeholder",  jQuery(label).html());
            jQuery(label).remove();
        }
    });
 }


function cf7fix() {
	jQuery('input.wpcf7-submit').click(function() { 			
			setTimeout(function(){
				jQuery('input.wpcf7-submit').attr('disabled','disabled');
			}, 100);			
		});

		jQuery(".wpcf7").on('wpcf7:submit', function(event){
			jQuery(this).find('input.wpcf7-submit').removeAttr('disabled');
		});

}

// CHECKS FOR STATIC / FIXED NAVIGATION
function navCheck(){
		var isDesktop = jQuery(document).width() > 1000 ? true : false; 
		// If document (your website) is wider than 1023px, notVisible = true, else notVisible = false
		if(!isDesktop) {
		   jQuery('#menu-bar-wrapper').removeClass('swipeup'); 
		   jQuery('#menu-bar-wrapper').removeClass('fixed');	
		} else { desktopNavToggle();  }
}

var toggler = false;
var previousScroll = 0;
function desktopNavToggle() {
	var offset = jQuery('#menu-bar-wrapper').offset();
    
    if(offset) {
	    var height = jQuery(window).scrollTop();		
		var currentScroll = jQuery(window).scrollTop();		

       if (currentScroll < previousScroll && toggler === true && height  < 95 && offset.top < 145){                   
		   jQuery('.home #menu-bar-wrapper').addClass('swipeup');		  
		   toggler = false;	
		
       }
       previousScroll = currentScroll;
		
	
	   if(height  < 89 && offset.top < 140) {			
			toggler = false;		
	    } else {
			toggler = true;
			jQuery('.home #menu-bar-wrapper').addClass('fixed');
			jQuery('.home #menu-bar-wrapper').removeClass('swipeup');
	    }
		if ( currentScroll < 30 ) { 
		   jQuery('.home #menu-bar-wrapper').removeClass('swipeup'); 
		   jQuery('.home #menu-bar-wrapper').removeClass('fixed'); 		   
		}
	   
    }
}	

// CUSTOM SLIDER WIDGET SCRIPT
function widgetSlider() {
	jQuery('.sbReviewsSlider').flickity({
	  // options
	  cellAlign: 'left',
	  contain: true,
	  autoPlay: 3500,
	  wrapAround: true,
	  pageDots: false,
	  prevNextButtons: false,
	  imagesLoaded: true,
	  cellSelector: ".wSlide",
	  arrowShape: { 
		  x0: 10,
		  x1: 70, y1: 40,
		  x2: 70, y2: 40,
		  x3: 70
		}
	});	
}

function initParallax() {		  
  
	  // use data-fptop to set the default starting point of the bg image
	  // eg. <div data-fptop="100" style="background-image:url('somebg.jpg')></div>
	  
	  var parallax = document.querySelectorAll(".fpparallax"),
	      speed = 0.3;
		
	  window.onscroll = function(){
	    [].slice.call(parallax).forEach(function(el,i){
		  
		  var w = window.innerWidth;
		  var mediaQueryVal = "";
		  var ParaOffset = el.offsetTop;	  
		  
		  if(w > 1024){ mediaQueryVal = el.getAttribute('data-fp-large'); }
		  else if (w <= 1024 && w > 640) { mediaQueryVal = el.getAttribute('data-fp-medium'); }
		  else if (w <= 640 && w > 420) { mediaQueryVal = el.getAttribute('data-fp-small'); }
		  else if (w <= 420) { mediaQueryVal = el.getAttribute('data-fp-xsmall'); }	  
		  
	      var windowYOffset = window.pageYOffset,
	      minusTop = mediaQueryVal ,
	         elBackgrounPosVanilla = "100% " + (windowYOffset * speed) + "px";
			 // elBackgrounPos = "50% " + (((windowYOffset - ParaOffset) * speed) - minusTop) + "px";
	      el.style.backgroundPosition = elBackgrounPosVanilla;	
	    });
	  };
}

function siteJsEssentials() {
	  // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();
    
	 // Makes sure last grid item floats left
	jQuery('.archive-grid .columns').last().addClass( 'end' );
	
	// Emma Form Tracking
	jQuery('#emma-form-submit').addClass('emmaTrackingLink');
	
	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').wrap("<div class='responsive-embed widescreen'/>");
	//console.log('hello dev team!');

}

// VIDEO FOR FRONT PAGE
function initHpVideo() {		
			var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
	jQuery('.promo .video').each(function() {
		var holder = jQuery(this);
		var video = holder.find('video');
		var isDesktop = jQuery(document).width() < 1025 ? true : false; 
		
		if (isTouchDevice && isDesktop) {
			video.remove();
			jQuery(".promo").addClass("mobile");
			jQuery(".promo").removeClass("desktop");
		} else {
			jQuery(".promo").addClass("desktop");
		}
	});
}

function checkVideo(){
var vid = document.getElementById("fpVideo");

	if (vid) {
		vid.onloadedmetadata = function() {   
		    jQuery('.loader').fadeOut('slow');
		};
	}
}

function initScroller(){
	
	jQuery('.scrollink').click(function() { 
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
		var target = jQuery(this.hash); 
		target = target.length ? target : jQuery('[name=' + this.hash.slice(1) +']');
		if (target.length) {
			jQuery('html,body').animate({
			scrollTop: target.offset().top-40
			}, 1000);				
			return false;
			}
		}
	});

}

//  coolColorOverlay Hover box 
//  this is dependent on /scss/sections/plugins/cool-color.scss (include it via style.scss)
/*
	- to add coolColorOverlay to and element in your templates add the class .coolColor 
	the js will look for a link with a class of .button to act as the trigger that will fade the background color when hovered.
	
	- if you would like to fade out any child elements with the color add a class of .unThis to them.  
	
	- Available data attributes for coolColorOverlay  
	
	data-cool-this="1" 
	this allows the color to fade away when we hover on the target button
	set value to 1 or true to enable and 0 or false to disable
	(by default this is disabled)
	
	data-image-src="url"
	(add this if you would like a background image)
	
	data-cool-color="primary"
	this chooses the overlay color. It pull directly from the foundation color pallet 
	the default / fallback is primary
	you may also set it to: secondary, success, warning, alert, black or white
	
	data-cool-btn="primary"
	this sets the hover color of the target button (if not set it will fallback to the data-cool-color value)
	you may also set it to: secondary, success, warning, alert, black or white
*/

function coolColorOverLay() {
	jQuery(".coolColor").each(function(){
		var ccattr = jQuery(this).attr('data-cool-color');
		var bcattr = jQuery(this).attr('data-cool-btn');
		if (typeof ccattr !== typeof undefined && ccattr !== false && ccattr !== '') {
			ccattr = jQuery(this).attr('data-cool-color');
		} else {
			ccattr = 'primary';
		}
		if (typeof bcattr !== typeof undefined && bcattr !== false && bcattr !== '') {
			bcattr = jQuery(this).attr('data-cool-btn');
		} else {
			bcattr = ccattr;
		}
		jQuery(this).children().wrapAll("<div class='coolContent'></div>");
		jQuery(this).children().find('.button').addClass(bcattr);
		var bgattr = jQuery(this).attr('data-image-src');
		if (typeof bgattr !== typeof undefined && bgattr !== false) {
			jQuery(this).addClass(ccattr).css({
				'background' : 'url('+bgattr+')',
				'background-repeat': 'no-repeat',
				'background-size': 'cover',
				'background-position': 'center top',
				'padding': '3rem 0 5rem',
			});
		} else {
			jQuery(this).css({
				'position': 'relative',
				'padding': '3rem 0 5rem',
			});			
		}
		var coolthis = jQuery(this).attr('data-cool-this');
		if (typeof coolthis !== typeof undefined && coolthis !== false && (coolthis === 'true'|| coolthis === '1') && (coolthis !== '' || coolthis !== 0 || coolthis !== 'false')) {
			jQuery(this).find('.button').hover( function(){
				jQuery(this).parents('.coolColor').toggleClass('unCoolThis');
			});
		} else {
			
		}
	}); 
}



/*
CSS Browser Selector v0.4.0 (Nov 02, 2010)
Rafael Lima (http://rafael.adm.br)
http://rafael.adm.br/css_browser_selector
License: http://creativecommons.org/licenses/by/2.5/
Contributors: http://rafael.adm.br/css_browser_selector#contributors
*/
function css_browser_selector(u){var ua=u.toLowerCase(),is=function(t){return ua.indexOf(t)>-1},g='gecko',w='webkit',s='safari',o='opera',m='mobile',h=document.documentElement,b=[(!(/opera|webtv/i.test(ua))&&/msie\s(\d)/.test(ua))?('ie ie'+RegExp.$1):is('firefox/2')?g+' ff2':is('firefox/3.5')?g+' ff3 ff3_5':is('firefox/3.6')?g+' ff3 ff3_6':is('firefox/3')?g+' ff3':is('gecko/')?g:is('opera')?o+(/version\/(\d+)/.test(ua)?' '+o+RegExp.$1:(/opera(\s|\/)(\d+)/.test(ua)?' '+o+RegExp.$2:'')):is('konqueror')?'konqueror':is('blackberry')?m+' blackberry':is('android')?m+' android':is('chrome')?w+' chrome':is('iron')?w+' iron':is('applewebkit/')?w+' '+s+(/version\/(\d+)/.test(ua)?' '+s+RegExp.$1:''):is('mozilla/')?g:'',is('j2me')?m+' j2me':is('iphone')?m+' iphone':is('ipod')?m+' ipod':is('ipad')?m+' ipad':is('mac')?'mac':is('darwin')?'mac':is('webtv')?'webtv':is('win')?'win'+(is('windows nt 6.0')?' vista':''):is('freebsd')?'freebsd':(is('x11')||is('linux'))?'linux':'','js']; c = b.join(' '); h.className += ' '+c; return c;}; css_browser_selector(navigator.userAgent);